module.exports = __webpack_public_path__ + "static/media/AD_VC.3c5fbabf.png";